/**
 * MA6200-G1, MA6200-G2, and MA3000 type aliases for device type detection in the WebUI.
 *
 * CANONICAL SOURCES:
 *   G1 → WEB_API/snmp-device-worker/src/main/resources/Ma6200g1DiscoveryMapping.yaml
 *   G2 → WEB_API/snmp-device-worker/src/main/resources/Ma6200g2DiscoveryMapping.yaml
 *   MA3000 → WEB_API/snmp-device-worker/src/main/resources/Ma3000DiscoveryMapping.yaml
 *   Keep MA6200 arrays in sync with the `devTypeAliases` lists in those files whenever they change.
 *   
 */

// ── MA6200-G1 ────────────────────────────────────────────────────────────────

// AU2 component — root controller (PRIMARY / SECONDARY refer to redundant AU2 pairs)
// YAML: componentType: AU2 → devTypeAliases: ["AU2", "A2", "AU", "-AU", "PRIMARY", "SECONDARY"]
export const AU2_TYPE_ALIASES = ["AU2", "A2", "AU", "-AU", "PRIMARY", "SECONDARY"] as const;

// RU2 component — remote unit
// YAML: componentType: RU2 → devTypeAliases: ["RU2", "RU", "RUE", "-RU"]
export const RU2_TYPE_ALIASES = ["RU2", "RU", "RUE", "-RU"] as const;

// E2O component — extension unit
// YAML: componentType: E2O → devTypeAliases: ["E2-O", "E2O"]
// Note: plain "E2" is also accepted here to handle legacy equipmentType values seen in the field.
export const E2O_TYPE_ALIASES = ["E2-O", "E2O", "E2"] as const;

// ── MA6200-G2 ────────────────────────────────────────────────────────────────

// A3 component — root controller
// YAML: componentType: A3 → devTypeAliases: ["AU3", "A3"]
export const AU3_TYPE_ALIASES = ["AU3", "A3"] as const;

// E3 component — extension unit
// YAML: componentType: E3 → devTypeAliases: ["EU3", "E3"]
export const E3_TYPE_ALIASES = ["EU3", "E3"] as const;

// RU3 component — remote unit
// YAML: componentType: RU3 → devTypeAliases: ["RU3", "RU"]
export const RU3_TYPE_ALIASES = ["RU3", "RU"] as const;

// ── MA3000 ─────────────────────────────────────────────────────────────────
// MA3000 equipment type aliases used for strict type matching in the WebUI
// Includes controller, module, and remote equipment families from DAS inventory.
export const MA3000_TYPE_ALIASES = ['HCM', 'ACM', 'RIM', 'OIM', 'RAU', 'RXU', 'MRU', 'MXU','GX','OCH','FCM', 'RXU67'] as const;

/**
 * Returns true if the given value (case-insensitive) contains or equals any of the provided aliases.
 */
export const matchesMa6200Alias = (
  value: string,
  aliases: readonly string[]
): boolean => {
  if (!value) return false;
  const upper = value.toUpperCase();
  return aliases.some((alias) => upper.includes(alias.toUpperCase()));
};

export const matchesMa3000Alias = (
  value: string,
  aliases: readonly string[]
): boolean => {
  if (!value) return false;
  const upper = value.toUpperCase().trim();

  return aliases.some(
    (alias) => upper === alias.toUpperCase()
  );
};